import {pipe} from 'fp-ts/lib/function'
import * as t from 'io-ts'
import * as tt from 'io-ts-types'
import {RA} from '../fp-ts-imp'

export const stringNullable = t.union([t.string, t.null])
export const numberNullable = t.union([t.number, t.null])
export const numberOrUndefined = t.union([t.number, t.undefined, t.null])
export const stringOrUndefined = t.union([t.string, t.undefined, t.null])
export const boolOrUndefined = t.union([t.boolean, t.undefined, t.null])
export const numberOrZero = tt.withFallback(t.number, 0, 'numberOrZero')

export const extractErrorKeys = (errs: t.Errors) =>
  pipe(
    errs,
    RA.map(({context}) =>
      pipe(
        context,
        RA.filter(({key}) => key !== ''),
      ),
    ),
    RA.flatten,
    RA.map(({key}) => key),
  )

// this is used to create a type guard to identify validation errors
// in error handling code
const ValidationErrorC = t.type({
  value: t.unknown,
  context: t.array(t.unknown),
  message: stringOrUndefined,
})

export const isValidationError = (err: unknown): err is [t.ValidationError] =>
  t.array(ValidationErrorC).is(err)
